export default __webpack_public_path__ + "static/media/HeroImage.de9c8ac5.png";